/**
 * Centralized registry for push-related React Query keys.
 *
 * Mirrors `@lib/cache/invite` and `@lib/cache/questions` (issue #653:
 * "No raw strings for cache keys"). Consumers get type-checked factories
 * instead of free-form arrays that drift across files.
 *
 * Coverage today: the OneSignal migration-status leaf query. Producer:
 * `usePushMigrationStatus` (asks the backend whether ONESIGNAL_PUSH_ENABLED
 * is on, i.e. whether OneSignal sends are live end-to-end). It has no
 * invalidator: the flag flips once per environment during the migration
 * rollout, so freshness is handled by `staleTime` + the default
 * refetch-on-focus, not by cache invalidation.
 *
 * The legacy `WEB_PUSH_KEYS` object in `useWebPushNotifications` stays where
 * it is: it is module-local with all producers and invalidators in that one
 * file, so it has no cross-file drift surface (the failure mode this registry
 * exists to prevent).
 */

/**
 * Backend push migration status (currently: whether OneSignal delivery is
 * live). Session-scoped singleton — no parameters.
 */
export const pushMigrationStatusKey = () => ['push', 'migration-status'] as const;
